import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import { Tooltip } from '@src/components/Tooltip';
import FrInfoSmallTwoSvg from '@src/svgs/fr-info-small-2.svg';
import { InfoTooltipProps } from './props';
import './styles.scss';

export const InfoTooltip: FC<InfoTooltipProps> = ({ tooltipText }) => {
  if (!tooltipText) {
    return null;
  }

  return (
    <Tooltip
      overlay={<div className="source-info-tooltip__text">{tooltipText}</div>}
      overlayStyle={{
        maxWidth: '25rem',
        textAlign: 'center',
      }}
      placement="top"
    >
      <Svg className="source-info-tooltip__icon" src={FrInfoSmallTwoSvg} />
    </Tooltip>
  );
};
